import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'label'
	| 'insertMenuTriggerLabel'
	| 'insertMenuUpload'
	| 'insertMenuAddLink'
	| 'insertMenuMention'
	| 'promptRecord'
	| 'promptSubmit'
	| 'promptPlaceholder';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.addButton.label',
		defaultMessage: 'Add',
		description: 'Add item button label within the Prompt screen',
	},
	insertMenuTriggerLabel: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel',
		defaultMessage: 'Insert rich content',
		description: 'Label for the button that opens the insert menu',
	},
	insertMenuUpload: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.upload',
		defaultMessage: 'Upload file',
		description:
			'Label for a menu item that allows the user to upload a file from their device. Shown in an insert menu within the AI editor prompt streaming interface.',
	},
	insertMenuAddLink: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink',
		defaultMessage: 'Add link',
		description:
			'Label for a drop-down menu item in the AI prompt insert menu. Clicking this item allows the user to insert a smart link into the editor content.',
	},
	insertMenuMention: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention',
		defaultMessage: 'Mention user',
		description:
			'Label for a menu item in an insert menu that allows the user to mention or tag another user in the document. Selecting this option lets the author reference a specific person by name.',
	},
	promptRecord: {
		id: 'fabric.editor.ai.screens.prompt.streaming.record',
		defaultMessage: 'Record',
		description: 'Accessible label for the microphone button',
	},
	promptSubmit: {
		id: 'fabric.editor.ai.screens.prompt.streaming.submit',
		defaultMessage: 'Submit',
		description: 'Accessible label for the send/submit button',
	},
	promptPlaceholder: {
		id: 'fabric.editor.ai.screens.prompt.streaming.placeholder',
		defaultMessage: 'Describe what you want to do',
		description: 'Placeholder hint displayed while the prompt input field is empty',
	},
});

export default message;
